__turbopack_context__.v({
  "chevron": "index-module-scss-module__JK9b5W__chevron",
  "chevron-left": "index-module-scss-module__JK9b5W__chevron-left",
  "chevron-right": "index-module-scss-module__JK9b5W__chevron-right",
  "close-expand": "index-module-scss-module__JK9b5W__close-expand",
  "container": "index-module-scss-module__JK9b5W__container",
  "content-image": "index-module-scss-module__JK9b5W__content-image",
  "content-thumbnail": "index-module-scss-module__JK9b5W__content-thumbnail",
  "dash": "index-module-scss-module__JK9b5W__dash",
  "dot": "index-module-scss-module__JK9b5W__dot",
  "expand-icon": "index-module-scss-module__JK9b5W__expand-icon",
  "expanded-chevron": "index-module-scss-module__JK9b5W__expanded-chevron",
  "expanded-chevron-left": "index-module-scss-module__JK9b5W__expanded-chevron-left",
  "expanded-chevron-right": "index-module-scss-module__JK9b5W__expanded-chevron-right",
  "fullscreen-image": "index-module-scss-module__JK9b5W__fullscreen-image",
  "image": "index-module-scss-module__JK9b5W__image",
  "thumbnail": "index-module-scss-module__JK9b5W__thumbnail",
  "thumbnail-button": "index-module-scss-module__JK9b5W__thumbnail-button",
  "thumbnail-image-container": "index-module-scss-module__JK9b5W__thumbnail-image-container",
  "thumbnail-image-container-active": "index-module-scss-module__JK9b5W__thumbnail-image-container-active",
  "tracer": "index-module-scss-module__JK9b5W__tracer",
  "tracer-btn": "index-module-scss-module__JK9b5W__tracer-btn",
  "wrapper-thumbnail": "index-module-scss-module__JK9b5W__wrapper-thumbnail",
});
